export const environment = {
  production: true,
  githubLink: 'http://github.com/AnSyn/imagery'
};
